<template>
  <div class="page_bottom_box">
    <div class="content-box">
      <ul>
        <li>
          <img src="/static/images/logo.png" alt="" />
        </li>
        <li
          class="hand"
          v-for="(nav, index) in nav_data"
          :key="index"
          @click="toPath(nav.url)"
        >
          {{ nav.name }}
        </li>
      </ul>
      <div class="p_btm">
        <div>
          <img src="../assets/img/index/fintech.png" alt="" />
          <p>
            专注于产业数字化与产融综合解决方案
            <i></i>
          </p>
        </div>
        <div class="p_cont">
          <b><i></i>地址</b>
          <h5>
            北京市朝阳区呼家楼街道京广中心商务楼10层
          </h5>
          <p>
            10th Floor, Jingguang Center Business Building, Hujialou<br />
            Sub-district, Chaoyang District, Beijing
          </p>
          <b class="phones"><i></i>电话</b>
          <h5>
            010-64726865
          </h5>
        </div>
        <div>
          <img src="../assets/img/index/code.png" alt="" />
          <p>关注三悦资讯</p>
          <h5>Focus on Sanyue</h5>
        </div>
      </div>
      <p class="copy">
        版权所有2015-2026@北京优品三悦科技发展有限公司&nbsp;&nbsp;&nbsp;
        <a style="margin-left: 20px" href="https://beian.miit.gov.cn/" target="_blank"
          >京ICP备16010991号-1&nbsp;&nbsp;&nbsp;</a
        >
        <a
          href="https://beian.mps.gov.cn/"
          target="_blank"
          style="margin-left: 20px;color:fff"
          >&nbsp;京公网安备11010502048124号
        </a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nav_data: [
        {
          name: "首页",
          url: "/"
        },
        {
          name: "产品&解决方案",
          url: "/solution"
        },
        {
          name: "客户案例",
          url: "/case"
        },
        {
          name: "核心技术",
          url: "/technology"
        },
        {
          name: "新闻动态",
          url: "/news"
        },
        {
          name: "党建+公益",
          url: "/party"
        },
        {
          name: "关于我们",
          url: "/about"
        }
      ]
    };
  },
  methods: {
    toPath(path) {
      this.$router.push(path);
      window.scrollTo(0, 0);
    }
  }
};
</script>

<style lang="scss" scoped>
.page_bottom_box {
  height: 513px;
  width: 100%;
  background: #262a36;
  color: #fff;

  .content-box {
    width: 90%;
    margin: 0 auto;

    ul {
      display: flex;
      align-items: flex-start;
      height: 80px;
      border-top: 1px solid rgba(255, 255, 255, 0.3);
      border-bottom: 1px solid rgba(255, 255, 255, 0.3);

      li {
        height: 80px;
        line-height: 80px;
        margin-right: 50px;
        font-weight: 400;
        font-size: 15px;
        color: rgba(255, 255, 255, 0.6);

        img {
          vertical-align: middle;
          margin-left: 50px;
        }
      }
      li:hover {
        color: #ff6633;
      }
    }
  }
}

.p_btm {
  margin-top: 100px;
  margin-bottom: 70px;
  display: flex;
  justify-content: space-around;

  div:nth-child(1) {
    margin-top: 40px;
    text-align: left;

    img {
      margin-bottom: 50px;
    }

    p {
      font-weight: 500;
      font-size: 29px;
      color: #ffffff;

      i {
        width: 505px;
        height: 17px;
        background: #ff6633;
        display: block;
        margin-top: -12px;
      }
    }
  }

  div:nth-child(3) {
    p {
      font-size: 16px;
      color: #ffffff;
      margin-top: 10px;
      text-align: center;
    }

    h5 {
      font-weight: 300;
      text-align: center;
      font-size: 9px;
      color: #e8e8ed;
    }
  }

  .p_cont {
    text-align: left;

    b {
      font-weight: 400;
      font-size: 16px;
      color: #e8e8ed;
      display: flex;
      align-items: center;

      i {
        width: 22px;
        height: 22px;
        display: inline-block;
        background: url("../assets/img/index/address.png") no-repeat;
        background-size: 100% 100%;
        margin-right: 5px;
      }
    }

    .phones {
      margin-top: 30px;

      i {
        background: url("../assets/img/index/phone.png") no-repeat;
      }
    }

    h5 {
      font-weight: 400;
      font-size: 16px;
      color: #e8e8ed;
      margin-top: 20px;
      margin-bottom: 5px;
    }

    h5:nth-child(2) {
      margin-top: 10px;
    }

    p {
      font-weight: 300;
      font-size: 13px;
      color: #e8e8ed;
    }
  }
}

.copy {
  width: 1200px;
  margin: 0 auto;
  font-weight: 300;
  font-size: 13px;
  color: #e8e8ed;
  a {
    color: #e8e8ed !important;
    font-weight: 300;
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PageBottom.vue